import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const kpiData = [
  {
    id: 'trir',
    label: 'TRIR',
    value: '0.42',
    unit: 'per 200k hrs',
    trend: -8.5,
    rag: 'green',
    sparkline: [0.58, 0.54, 0.51, 0.49, 0.47, 0.45, 0.42],
    icon: 'Activity',
  },
  {
    id: 'ltifr',
    label: 'LTIFR',
    value: '0.18',
    unit: 'per 200k hrs',
    trend: -12.3,
    rag: 'green',
    sparkline: [0.28, 0.25, 0.24, 0.22, 0.21, 0.20, 0.18],
    icon: 'TrendingDown',
  },
  {
    id: 'near-miss',
    label: 'Near Miss Rate',
    value: '3.2',
    unit: 'per month',
    trend: 14.2,
    rag: 'amber',
    sparkline: [2.1, 2.4, 2.8, 3.0, 2.9, 3.1, 3.2],
    icon: 'AlertTriangle',
  },
  {
    id: 'active-permits',
    label: 'Active Permits',
    value: '47',
    unit: 'open now',
    trend: 5.6,
    rag: 'amber',
    sparkline: [38, 41, 43, 45, 44, 46, 47],
    icon: 'FileText',
  },
  {
    id: 'interlocks',
    label: 'Interlocks Bypassed',
    value: '3',
    unit: 'active',
    trend: 50.0,
    rag: 'red',
    sparkline: [1, 1, 2, 2, 2, 3, 3],
    icon: 'ShieldOff',
  },
  {
    id: 'lotos',
    label: 'LOTOs Active',
    value: '12',
    unit: 'in progress',
    trend: -8.0,
    rag: 'green',
    sparkline: [16, 15, 14, 13, 13, 12, 12],
    icon: 'Lock',
  },
];

const ragColors = {
  green: { bg: 'bg-emerald-500/10', dot: 'bg-emerald-500', text: 'text-emerald-500', border: 'border-emerald-500/30', line: '#10b981' },
  amber: { bg: 'bg-amber-500/10', dot: 'bg-amber-500', text: 'text-amber-500', border: 'border-amber-500/30', line: '#f59e0b' },
  red: { bg: 'bg-red-500/10', dot: 'bg-red-500', text: 'text-red-500', border: 'border-red-500/30', line: '#ef4444' },
};

const SparklineChart = ({ data, color }) => (
  <ResponsiveContainer width="100%" height={40}>
    <LineChart data={data?.map((v, i) => ({ v, i }))}>
      <Line type="monotone" dataKey="v" stroke={color} strokeWidth={2} dot={false} />
      <Tooltip
        contentStyle={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', borderRadius: 6, fontSize: 11 }}
        formatter={(v) => [v, '']}
        labelFormatter={() => ''}
      />
    </LineChart>
  </ResponsiveContainer>
);

const GlobalKPICards = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {kpiData?.map((kpi) => {
        const rag = ragColors?.[kpi?.rag];
        const isUp = kpi?.trend > 0;
        return (
          <div key={kpi?.id} className={`bg-card border ${rag?.border} rounded-xl p-4 flex flex-col gap-2`}>
            <div className="flex items-center justify-between">
              <div className={`w-8 h-8 rounded-lg ${rag?.bg} flex items-center justify-center`}>
                <Icon name={kpi?.icon} size={16} color={`var(--color-${kpi?.rag === 'green' ? 'success' : kpi?.rag === 'amber' ? 'warning' : 'danger'})`} />
              </div>
              <div className="flex items-center gap-1">
                <span className={`w-2 h-2 rounded-full ${rag?.dot} animate-pulse`} />
                <span className={`text-xs font-semibold uppercase ${rag?.text}`}>{kpi?.rag}</span>
              </div>
            </div>
            <div>
              <p className="text-xs text-muted-foreground font-medium">{kpi?.label}</p>
              <p className="text-2xl font-bold text-foreground leading-tight">{kpi?.value}</p>
              <p className="text-xs text-muted-foreground">{kpi?.unit}</p>
            </div>
            <SparklineChart data={kpi?.sparkline} color={rag?.line} />
            <div className={`flex items-center gap-1 text-xs font-medium ${isUp ? 'text-red-400' : 'text-emerald-400'}`}>
              <Icon name={isUp ? 'TrendingUp' : 'TrendingDown'} size={12} />
              <span>{Math.abs(kpi?.trend)}% vs last period</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GlobalKPICards;